import { render, staticRenderFns } from "./PublicQuery.vue?vue&type=template&id=ac5fcf9c&"
import script from "./PublicQuery.vue?vue&type=script&lang=ts&"
export * from "./PublicQuery.vue?vue&type=script&lang=ts&"
import style0 from "./PublicQuery.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports